import { STATE_IDENTIFIER } from "./constants";

const {
  REQUESTS_HISTORY_FETCH_LIMIT,
  RETRYABLE_REQUEST_TYPES,
  SMS_ENABLED,
  SMS_MOBILE_NUMBER_EDITABLE_BY_USER,
  MODIFY_PROFILE_CA_OTP_ENABLED,
  MODIFY_PROFILE_SEC_QUESTIONS_ENABLED,
  MODIFY_PROFILE_UIGP_OTP_ENABLED,
  DELEGATE_CONSULTANT_ENABLED,
} = STATE_IDENTIFIER;

const emptyState = {
  [REQUESTS_HISTORY_FETCH_LIMIT]: 0,
  [RETRYABLE_REQUEST_TYPES]: [],
  [SMS_ENABLED]: false,
  [SMS_MOBILE_NUMBER_EDITABLE_BY_USER]: false,
  [MODIFY_PROFILE_CA_OTP_ENABLED]: false,
  [MODIFY_PROFILE_SEC_QUESTIONS_ENABLED]: false,
  [MODIFY_PROFILE_UIGP_OTP_ENABLED]: false,
  [DELEGATE_CONSULTANT_ENABLED]: false,
};

export default emptyState;
